<div class="operation-container" [ngClass]="responsive.deviceAndOrientation">
    <app-ops-alarm-topbar-xsmall
        [title]="pageTitle"
        [hidden]="!responsive.isXSmall()"
        (onBackEmit)="onBack()"
    >
        <app-input-search-wrapper>
            <input
                type="text"
                class="text"
                #wrapTarget
                [(ngModel)]="filterOption.channel"
                (focus)="showSearchDivider = false"
                (blur)="showSearchDivider = false"
                (ngModelChange)="onSearchInputChange()"
                placeholder="Search"
                (keydown.enter)="onSearchClick(); dataFilter()"
            />
        </app-input-search-wrapper>
    </app-ops-alarm-topbar-xsmall>
    <div class="filter-wrap" #filters>
        <!-- Search Inputs -->
        <div class="filter-top">
            <div
                class="search-container"
                *ngIf="!responsive.isXSmall() && !responsive.isSmall()"
            >
                <div class="search-box" style="border-right: 1px">
                    <app-labelled-block-input-wrapper header="Channel">
                        <input
                            type="text"
                            class="text"
                            #wrapTarget
                            [(ngModel)]="filterOption.channel"
                            (focus)="showSearchDivider = false"
                            (blur)="showSearchDivider = true"
                            placeholder="Search Channel Name or Number"
                        />
                    </app-labelled-block-input-wrapper>
                </div>

                <div
                    class="search-divider"
                    [ngStyle]="{
                        'background-color': showSearchDivider
                            ? '#FFFFFF80'
                            : '#FFFFFF00'
                    }"
                ></div>

                <div class="search-box">
                    <app-labelled-block-input-wrapper header="Status">
                        <input
                            type="text"
                            class="text"
                            #wrapTarget
                            [(ngModel)]="filterOption.status"
                            (focus)="showSearchDivider = false"
                            (blur)="showSearchDivider = true"
                            placeholder="Search alarm level status"
                        />
                    </app-labelled-block-input-wrapper>
                </div>
                <div
                    class="search-button-container"
                    (click)="onSearchClick(); dataFilter()"
                >
                    <button class="primary">
                        <mat-icon
                            style="width: 20px; height: 20px"
                            svgIcon="search"
                        ></mat-icon>
                    </button>
                </div>
            </div>
            <div class="search-input-container" *ngIf="responsive.isSmall()">
                <div class="search-box">
                    <app-input-search-wrapper>
                        <input
                            type="text"
                            class="text"
                            #wrapTarget
                            [(ngModel)]="filterOption.channel"
                            (focus)="showSearchDivider = false"
                            (blur)="showSearchDivider = false"
                            (ngModelChange)="onSearchInputChange()"
                            placeholder="Search Channel Name or Number"
                            (keydown.enter)="onSearchClick(); dataFilter()"
                        />
                    </app-input-search-wrapper>
                </div>
            </div>
            <div
                class="reset-filters"
                *ngIf="displayResetOption"
                #resetFilterButton
                (click)="refreshFilters()"
            >
                <mat-icon
                    class="cancel-icon"
                    svgIcon="refresh"
                    (click)="refreshFilters()"
                ></mat-icon>
                {{ "ops.alarm-page.reset-filters" | translate }}
            </div>
            <div
                class="reset-filters"
                *ngIf="isClearFilterVisible()"
                (click)="resetFilter(); $event.stopPropagation()"
            >
                <mat-icon class="cancel-icon" svgIcon="cancel-close"></mat-icon>
                {{ "ops.alarm-page.clear-filters" | translate }}
            </div>
        </div>
        <div class="calendar-search">
            <div class="wrapper" style="border-right: 1px">
                <app-calendar
                    label="Date of Recovery"
                    name="datetime"
                    [clickRefreshSubject]="clickRefreshSubject"
                    (onSelectDateEvent)="handleCalendarDate($event)"
                ></app-calendar>
            </div>
        </div>
    </div>

    <div class="table-container">
        <div
            class="table"
            #dynamicMaxHeight="appDynamicMaxHeight"
            appDynamicMaxHeight
            [ngClass]="{ 'table-no-height-limit': removeHeightLimits }"
        >
            <app-operation-table-header
                #tHeader
                [hidden]="!responsive.isXLarge()"
                (onRefresh)="onClickRefresh()"
            ></app-operation-table-header>
            <app-operation-table-header-compact
                #tHeaderCompact
                [hidden]="responsive.isXLarge()"
                (onRefresh)="onClickRefresh()"
            ></app-operation-table-header-compact>
            <div class="main-content" #tableContent (scroll)="onScroll()">
                <app-ops-table-body
                    [isLoading]="false"
                    [loadingTemplateRows]="6"
                >
                    <ng-container *ngIf="responsive.isXLarge()">
                        <app-operation-table-row
                            *ngFor="
                                let operation of filtredOperationsData
                                    | alarmDataSort: tHeader.sort
                                    | slice: pageStart : pageEnd;
                                index as i
                            "
                            [operation]="operation"
                            [index]="pageStart + i + 1"
                            (onShowDetail)="onDetail($event)"
                        ></app-operation-table-row>
                    </ng-container>

                    <ng-container *ngIf="responsive.isLarge()">
                        <app-operation-table-row-compact
                            *ngFor="
                                let operation of filtredOperationsData
                                    | alarmDataSort: tHeaderCompact.sort
                                    | slice: pageStart : pageEnd;
                                index as i
                            "
                            [operation]="operation"
                            [index]="displayStart + i + 1"
                            (onShowDetail)="onDetail($event)"
                        ></app-operation-table-row-compact>
                    </ng-container>

                    <ng-container
                        *ngIf="
                            responsive.isMedium() ||
                            responsive.isSmall() ||
                            responsive.isXSmall()
                        "
                    >
                        <app-operation-table-row-wrap
                            *ngFor="
                                let operation of filtredOperationsData
                                    | alarmDataSort: tHeaderCompact.sort
                                    | slice: pageStart : pageEnd;
                                index as i
                            "
                            [operation]="operation"
                            (onShowDetail)="onDetail($event)"
                        >
                        </app-operation-table-row-wrap>
                    </ng-container>
                </app-ops-table-body>
            </div>
            <div class="page-list-container">
                <app-page-list
                    [pages]="pageCount"
                    [(currentPage)]="currentPage"
                    [displayedPageLimit]="displayedPageLimitCount()"
                    [hidden]="
                        responsive.isXSmall() || responsive.isHandsetLandscape()
                    "
                >
                </app-page-list>
            </div>
        </div>
    </div>
</div>
<app-ops-alarm-to-top
    (onTopEmit)="onTop()"
    *ngIf="
        (responsive.isXSmall() || responsive.isHandset()) &&
        isScrollBtnVisible()
    "
></app-ops-alarm-to-top>
<app-operation-detail-overlay
    #oprationDetailOverlay
    [operation]="operationDetail"
></app-operation-detail-overlay>
